import { Radius } from '../../../Types/Location'

const radiusUnits: Record<Radius['unit'], string> = {
  mi: 'miles',
  km: 'kilometres',
}

export default radiusUnits
